import React, { useState, useEffect } from 'react';
import { Redirect } from "react-router-dom";
import PdvService from '../../../services/pdv';
import { cpfOrCnpjMask, unMask } from '../../../commons/masks';
import { convertPercentToDecimal } from '../../../commons/utils';
import useForm from '../../components/useForm';
import PdvForm from '../form';

const PdvNewForm = (props) => {
  const [redirectTo, setRedirectTo] = useState(null);

  const initialFormValues = {
    cpf_cnpj: cpfOrCnpjMask(props.cpf||''),
    name: '',
    email: '',
    birthday: '',
    phone: '',
    password: '',
    discount: 0,
    isPartner: '',
    address: {
      street: '',
      number: '',
      district: '',
      city: '',
      zipCode: '',
    }
  }

  const {
    values,
    setValues,
    status,
    setStatus,
    stateButton,
    setStateButton,
    handleInputChange
  } = useForm(initialFormValues);

  useEffect(() => {
    PdvService.cleanPdvCache();
  }, [])

  const handleSubmit = async (evt) => {
    evt.preventDefault();
    setStatus('');
    setStateButton("loading");
    try {
      const data = {
        ...values,
        cpf_cnpj: unMask(values.cpf_cnpj),
        birthday: values.birthday.replace(/\//g,'-'),
        phone: unMask(values.phone),
        discount: convertPercentToDecimal(values.discount),
        isPartner: (values.isPartner === '1'),
        address: {
          ...values.address,
          zipCode: unMask(values.address.zipCode)
        }
      }
      const response = await PdvService.register(data);
      setStatus(['success', response.data.message]);
    } catch(e) {
      if (e.response)
        setStatus(['danger', `${e.response.status}: ${e.response.data.errors}`]);
      else
        setStatus(['danger', `${e}`]);
    }
    setStateButton('');
  }

  if (redirectTo)
    return <Redirect to={{pathname: redirectTo}} />

  const goToFind = () => setRedirectTo('/pdv/find');

  return (
    <PdvForm 
      newRecord={true}
      status={status} 
      setValues={setValues}
      stateButton={stateButton} 
      values={values} 
      handleInputChange={handleInputChange}
      handleSubmit={handleSubmit}
      handleClickBack={goToFind}
    />
  )

}

export default PdvNewForm;
